const subString = (string, maxLength) => {
  if (string.length > maxLength) {
    return `${string.substring(0, maxLength)} ...`;
  } else {
    return string;
  }
};

export default subString;
